import React from "react";
// svgs
import Close from '../assets/icons/icon_close.png';

/**
 *  버튼있는 알림창 
 */
const Alert = props => {
  const { btnTxt, alertTxt, double, onClose, onConfirm } = props.settings;

  return (
    <>
      <div className="modal">
        <div className="modal-content">
          <div className="alert__top flx-box">
            <img className="crs-btn" src={Close} onClick={onClose} alt="close-btn" />
          </div>
          <div className="alert__middle"><span>{alertTxt}</span></div>
          <div className="alert__bottom flex mt-1">
            {
              !double
                ?
                <button onClick={onClose} className="crs-btn positive-btn">닫기</button>
                :
                <>
                  <button onClick={onClose} className="crs-btn alert__cancel-btn negative-btn">닫기</button>
                  <button onClick={onConfirm} className="crs-btn positive-btn">{btnTxt}</button>
                </>
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default Alert;